import { render } from "./TableWithBorder.vue?vue&type=template&id=55210488"
import script from "./TableWithBorder.vue?vue&type=script&lang=ts"
export * from "./TableWithBorder.vue?vue&type=script&lang=ts"
script.render = render

export default script